export default __webpack_public_path__ + "static/media/title_ja_sp.05a7fa0d.png";